// Import model
import { DataviewContactAssignmentResponse } from '../models/DataviewContactAssignmentResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ContactAssignment } from '../models/ContactAssignment';
import { DataView } from '../models/DataView';
import { FilterContactAssignmentRequest } from '../models/FilterContactAssignmentRequest';

// Import dependency serializers (for complex types)
import { ContactAssignmentSerializer } from './ContactAssignmentSerializer';
import { DataViewSerializer } from './DataViewSerializer';
import { FilterContactAssignmentRequestSerializer } from './FilterContactAssignmentRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewContactAssignmentResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewContactAssignmentResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewContactAssignmentResponse instance
   */
  static deserialize(json: string): DataviewContactAssignmentResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewContactAssignmentResponse instance
   */
  static fromObject(obj: any): DataviewContactAssignmentResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewContactAssignmentResponse');
    }


    const instance: DataviewContactAssignmentResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        ContactAssignmentSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterContactAssignmentRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewContactAssignmentResponse instances
   */
  static deserializeArray(json: string): DataviewContactAssignmentResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewContactAssignmentResponse instance to a JSON string
   */
  static serialize(instance: DataviewContactAssignmentResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewContactAssignmentResponse instance to a plain object
   */
  static toObject(instance: DataviewContactAssignmentResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        ContactAssignmentSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterContactAssignmentRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewContactAssignmentResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewContactAssignmentResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
